/**
 * Night Owl theme colors for code blocks.
 *
 * TECHNICAL DEBT: These are hardcoded color values that should use Pluma tokens.
 * However, Pluma currently lacks dark theme tokens for code blocks (see: themeVars.color).
 * The Night Owl theme is used for consistency with the CodeBlock component's built-in
 * "night-owl" darkTheme option.
 *
 * When Pluma adds dark theme tokens, replace with:
 * - background: themeVars.color['surface-inverse'] or similar
 * - text: themeVars.color['text-inverse'] or similar
 *
 * @see https://shiki.style/themes - Night Owl theme reference
 */
export const CODE_BLOCK_THEME = {
  background: '#011627',
  skeletonHighlight: '#1e3a5f',
  text: '#d6deeb',
} as const;

// Modal content offset to compensate for ModalBody padding (12px on each side)
export const MODAL_BODY_PADDING = '12px';
export const MODAL_CONTENT_NEGATIVE_MARGIN = `-${MODAL_BODY_PADDING}`;
export const MODAL_CONTENT_EXTRA_WIDTH = `calc(100% + ${MODAL_BODY_PADDING} * 2)`;
